module.exports = __webpack_public_path__ + "img/home_yunfeishixiaochaxun.8f44f10.webp";